export const GTAG_ID = process.env.REACT_APP_GTAG_ID || '';

export const tagManagerArgs = {
  gtmId: GTAG_ID,
};
